import { AdditionalBuildingDtoSSX } from 'Api/insurance/types/insurance.dto.types';
import { HouseCoverage } from 'Types/coverages/coverages.types';
import { OwnContributionCode } from '../common/OwnContributionV2/ownContribution.constants';
import {
  AdditionalBuildingFields,
  AdditionalBuildingPriceRequest,
} from '../commonBuilding/AdditionalBuildings/additionalBuildings.types';
import { BaseBuildingValues } from '../commonBuilding/commonBuilding.types';

export interface ChangeHouseFormValues extends BaseBuildingValues {
  coverage: HouseCoverage;
  ownContribution: string | undefined;
  ownContributionCode: string;
  hasBurglarAlarm: boolean;
  hasFireAlarm: boolean;
  hasWaterGuard: boolean;
  hasPipeInPipeSystem: boolean;
  hasCircuitBreakers: boolean;
  rentalStatus: RentalValue;
  validNumberOfUnits?: boolean;
  validNumberOfResidents?: boolean;
  addressIsOnRegisteredAddress?: boolean;
  additionalBuildings: AdditionalBuildingFields[];
}

export const houseValuesToShowInBlueBox = [
  'grossArea',
  'livingFloorSpace',
  'hasBurglarAlarm',
  'hasFireAlarm',
  'hasWaterGuard',
  'coverage',
  // 'ownContribution',
  // 'ownContributionCode',
  'hasPipeInPipeSystem',
  'hasCircuitBreakers',
  'rentalStatus',
];

export interface ChangeHousePriceRequest
  extends Omit<ChangeHouseInsuranceRequest, 'additionalBuildings'> {
  additionalBuildings: AdditionalBuildingPriceRequest[];
}

export type ChangeHousePriceMapper = ChangeHousePriceRequest;

export interface ChangeHouseInsuranceRequest extends BaseBuildingValues {
  coverage: HouseCoverage;
  ownContribution: number;
  ownContributionCode: OwnContributionCode;
  hasBurglarAlarm: boolean;
  hasFireAlarm: boolean;
  hasWaterGuard: boolean;
  hasRental: boolean;
  hasPartialRental: boolean;
  hasPipeInPipeSystem: boolean;
  hasCircuitBreakers: boolean;
  additionalBuildings: AdditionalBuildingDtoSSX[];
}

export enum RentalValue {
  FULL_RENTAL = 'fullRental',
  PARTIAL_RENTAL = 'partialRental',
  NO_RENTAL = 'noRental',
}
